import { useEffect, useCallback, useState } from 'react'

export const useInterimValue = ({ value, onChange }) => {
  const [interimValue, setInterimValue] = useState(value)

  const handleChange = useCallback(
    (newValue, ...args) => {
      setInterimValue(newValue)
      // Next macrotask. CRA's webpack 4 polyfilled the Node-only setImmediate
      // global; Vite does not, so use the browser equivalent.
      setTimeout(() => {
        onChange(newValue, ...args)
      }, 0)
    },
    [setInterimValue, onChange],
  )

  useEffect(
    () => {
      setInterimValue(value)
    },
    [value],
  )

  return [interimValue, handleChange]
}
